<template>
    <AppNavigation>
        <mdb-container fluid>
            <mdb-row class="mb-3">
                <mdb-col col="11">
                    <h1 class="h1-responsive">Rider Transaction Summary</h1>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col md="2">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true" v-model="date_from" label="Date From" />
                    </div>
                </mdb-col>
                <mdb-col md="2">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true"  v-model="date_to" label="Date To" />
                    </div>
                </mdb-col>
                <mdb-col md="3" class="d-flex align-items-center">
                    <select v-model="rider_select" class="browser-default custom-select">
                        <option value="">All Rider</option>
                        <option v-for="partner in partners" v-bind:key="partner.id" :value="partner.partner_profile.id">[ {{partner.partner_profile.partner_code}} ] - {{partner.partner_profile.fullname}}</option>
                    </select>
                </mdb-col>
                <mdb-col md="3" class="d-flex align-items-center">
                    <select v-model="type" class="browser-default custom-select">
                        <option value="">All Type</option>
                        <option value="FULL">Full Time</option>
                        <option value="PART">Part Time</option>
                        <option value="TEST">Test</option>
                    </select>
                </mdb-col>
                <mdb-col md="2" class="d-flex align-items-center">
                    <mdb-btn @click="getData()" v-if="!loading" outline="primary" size="sm"><mdb-icon icon="search" /> Search</mdb-btn>
                    <mdb-spinner small v-if="loading" />
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col col="12">
                    <mdb-spinner small v-if="excel_loading" />
                    <mdb-btn outline="info" size="sm" v-if="!loading && !excel_loading" @click="downloadExcel()"><mdb-icon icon="file-excel" /> Download Excel within Duration</mdb-btn>
                    <mdb-btn outline="warning" size="sm" v-if="!loading && !print_loading" @click="print()"><mdb-icon icon="print" /> Print</mdb-btn>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col col="12">
                    <p class="text-danger">Please do not use this to generate data before 8-11-2021. The result may not be accurate.</p>
                </mdb-col>
            </mdb-row>
            <hr>
            <mdb-row>
            </mdb-row>
            <div v-if="loading">Wait.. Processing dont panic...</div>
            <mdb-tbl id="print-html" responsive striped v-if="!loading">
                <mdb-tbl-head>
                <tr>
                    <th width="3%">#</th>
                    <th width="8%">Code</th>
                    <th width="12%">Name</th>
                    <th width="7%" class="text-right">B/F</th>
                    <th width="7%" class="text-right">PB</th>
                    <th width="7%" class="text-right">COD</th>
                    <th width="7%" class="text-right">Admin TopUp</th>
                    <th width="7%" class="text-right">Admin Deduct</th>
                    <th width="7%" class="text-right">Rider TopUp</th>
                    <th width="7%" class="text-right">Rider Withdraw</th>
                    <th width="7%" class="text-right">Dispute Compensate</th>
                    <th width="7%" class="text-right">Dispute Penalty</th>
                    <th width="7%" class="text-right">C/F</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                <tr style="cursor: pointer" v-for="(record, index) in records" :key="record.id">
                    <td>{{index+1}}</td>
                    <td>
                        {{record.partner_profile.partner_code}}
                    </td>
                    <td @click="navigateTransaction(record)" class="href-transaction">
                        {{record.partner_profile.fullname}}
                        <!-- <a target="_blank"  ></a> -->
                    </td>
                    <td class="text-right text-weight-bold" style="font-weight: bold;">
                        {{getAmount(record.opening_balance)}}
                    </td>
                    <td class="text-right">
                        {{getAmount(record.PB)}}
                    </td>
                    <td class="text-right text-danger">
                        {{getAmount(record.COD)}}
                    </td>
                    <td class="text-right">
                        {{getAmount(record.admin_topup)}}
                    </td>
                    <td class="text-right text-danger">
                        {{getAmount(record.admin_deduct)}}
                    </td>
                    <td class="text-right">
                        {{getAmount(record.partner_topup)}}
                    </td>
                    <td class="text-right text-danger">
                        {{getAmount(record.partner_withdraw)}}
                    </td>
                    <td class="text-right">
                        {{getAmount(record.dispute_compensate)}}
                    </td>
                    <td class="text-right text-danger">
                        {{getAmount(record.dispute_penalty)}}
                    </td>
                    <td class="text-right" style="font-weight: bold;">
                        {{getAmount(record.closing_balance)}}
                    </td>
                </tr>
                <tr class="pink lighten-4">
                    <td colspan="3" class="text-center" style="font-weight: bold">Total</td>
                    <td class="text-right text-weight-bold" style="font-weight: bold;">
                        {{getAmount(total_opening)}}
                    </td>
                    <td class="text-right" style="font-weight: bold">
                        {{getAmount(total_pb)}}
                    </td>
                    <td class="text-right text-danger" style="font-weight: bold">
                        {{getAmount(total_cod)}}
                    </td>
                    <td class="text-right" style="font-weight: bold">
                        {{getAmount(total_admin_topup)}}
                    </td>
                    <td class="text-right text-danger" style="font-weight: bold">
                        {{getAmount(total_admin_deduct)}}
                    </td>
                    <td class="text-right" style="font-weight: bold">
                        {{getAmount(total_partner_topup)}}
                    </td>
                    <td class="text-right text-danger" style="font-weight: bold">
                        {{getAmount(total_partner_withdraw)}}
                    </td>
                    <td class="text-right" style="font-weight: bold">
                        {{getAmount(total_dispute_compensate)}}
                    </td>
                    <td class="text-right text-danger" style="font-weight: bold">
                        {{getAmount(total_dispute_penalty)}}
                    </td>
                    <td class="text-right" style="font-weight: bold;">
                        {{getAmount(total_closing)}}
                    </td>
                </tr>
                </mdb-tbl-body>
            </mdb-tbl>
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbRow, mdbCol, mdbBtn, mdbDatePicker, mdbIcon, mdbSpinner, mdbTbl, mdbTblHead, mdbTblBody} from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {amount} from '../js/helper';
// import {APP_STORAGE_URL} from '../js/config';

export default {
  name: 'partner_wallet_transactions',
  components: {
    mdbContainer, mdbRow, mdbCol, mdbBtn, mdbDatePicker,
    AppNavigation, mdbIcon, mdbSpinner, mdbTbl, mdbTblHead, mdbTblBody
  },
  data: ()=>({
      date_from: "",
      date_to: "",
      loading:false,
      records: [],
      partners: [],
      rider_select: "",
      type: "",
      print_loading: false,
      excel_loading: false,

      //total data
      total_cod: 0,
      total_pb: 0,
      total_dispute_compensate: 0,
      total_dispute_penalty: 0,
      total_admin_topup: 0,
      total_admin_deduct: 0,
      total_partner_topup: 0,
      total_partner_withdraw: 0,
      total_opening: 0,
      total_closing: 0
  }),
  methods: {
    closeModal(){
        this.partner_transaction_detail_modal=false;
    },
    getData(){
        if(this.loading){
            return false;
        }
        this.loading=true;
        this.total_cod=0;
        this.total_pb=0;
        this.total_dispute_compensate=0;
        this.total_dispute_penalty=0;
        this.total_admin_topup=0;
        this.total_admin_deduct=0;
        this.total_partner_topup=0;
        this.total_partner_withdraw=0;
        this.total_closing=0;
        this.total_opening=0;
        ajax({
            url: "admin/get_wallet_transaction_summary",
            data: {
                date_from: this.date_from,
                date_to: this.date_to,
                partner_profile_id: this.rider_select,
                type: this.type
            },
            complete: ()=>this.loading=false,
            success: result=>{
                this.records=result.data;

                let total_cod= 0;
                let total_pb= 0;
                let total_dispute_compensate= 0;
                let total_dispute_penalty= 0;
                let total_admin_topup= 0;
                let total_admin_deduct= 0;
                let total_partner_topup= 0;
                let total_partner_withdraw= 0;
                let total_opening=0;
                let total_closing=0;
                result.data.forEach(element => {
                    total_cod += parseFloat(element.COD);
                    total_pb += parseFloat(element.PB);
                    total_dispute_compensate += parseFloat(element.dispute_compensate);
                    total_dispute_penalty += parseFloat(element.dispute_penalty);
                    total_admin_topup += parseFloat(element.admin_topup);
                    total_admin_deduct += parseFloat(element.admin_deduct);
                    total_partner_topup += parseFloat(element.partner_topup);
                    total_partner_withdraw += parseFloat(element.partner_withdraw);
                    total_opening+=parseFloat(element.opening_balance);
                    total_closing+=parseFloat(element.closing_balance);
                });
                this.total_cod=total_cod;
                this.total_pb=total_pb;
                this.total_dispute_compensate=total_dispute_compensate;
                this.total_dispute_penalty=total_dispute_penalty;
                this.total_admin_topup=total_admin_topup;
                this.total_admin_deduct=total_admin_deduct;
                this.total_partner_topup=total_partner_topup;
                this.total_partner_withdraw=total_partner_withdraw;
                this.total_closing=total_closing;
                this.total_opening=total_opening;
            },
        }, this)
    },
    getRiderData(){
        ajax({
            url: "admin/get_partner_list",
            success: result=>{
                this.partners=result.data;
                this.partners.sort((a, b)=>{
                    if(a.partner_profile.partner_code < b.partner_profile.partner_code) { return -1; }
                    if(a.partner_profile.partner_code > b.partner_profile.partner_code) { return 1; }
                    return 0;
                })
            },
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    getAmount(param){
        return amount(param);
    },
    navigateTransaction(record){
        window.open(`/partner_wallet_transactions/${record.partner_profile.id}/${this.date_from}/${this.date_to}`);
    },
    downloadExcel(){
        this.excel_loading=true;
        ajax({
            url: "admin/excel_wallet_transaction_summary",
            data: {
                date_from: this.date_from,
                date_to: this.date_to,
            },
            success: ()=>{
                // window.open(APP_STORAGE_URL+result.data);
                this.$notify.success({message: 'Downloaded Document will be available in few minutes time', position:'top right', timeOut: 5000});
            },
            complete: ()=>this.excel_loading=false,
            fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
        })
    },
    async print(){
        this.print_loading=true;
        await this.$htmlToPaper('print-html');
        this.print_loading=false;
    }
  },
  mounted: function(){
    let date = new Date();
    let month = date.getMonth()+1;
    this.date_from=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
    this.date_to=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
    if(this.$route.params.id){
        this.rider_select=this.$route.params.id;
    }
    this.getRiderData();
    // this.getData();
  }
}
</script>

<style scoped>
.href-transaction{
    color: #64b5f6;
    cursor: pointer;
}
.href-transaction:hover{
    color: #1e88e5;
    cursor: pointer;
}
</style>